import React, { useEffect, useState } from "react";
import Classes from "./styles/style.module.css";
import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "../../services/user";
import getProfileImage from "../../Hooks/getProfileImage";
import VerifedIcon from "../../images/icons/verifiedIcon.svg";
import EditIcon from "../../images/icons/edit-secondary-outlined.svg";
import CustomModal from "../ModalComonent";
import AvatarSelector from "./AvatarSelector";
import { setUserProfileImage } from "../../redux/actions/User";
import { motion } from "framer-motion";
import RCoin from "../../images/icons/RCoin.png";
import { useNavigate } from "react-router-dom";

const ProfileAvatar = ({ showInfo }) => {
  const [avatar, setAvatar] = useState("");
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { currentUser,userPoint } = useSelector(({ user }) => user);
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      setAvatar(currentUser.profileImage);
    }

    if (!currentUser?._id) {
      dispatch(UsersRequests.getme());
    }
  }, [currentUser]);

  const handleChageAvatar = (fileName) => {
    setAvatar(fileName);
    dispatch(setUserProfileImage(fileName));
    dispatch(
      UsersRequests.updateUser(currentUser?._id || currentUser.id, {
        profileImage: fileName,
      })
    );
    setShowModal(false);
  };

  return (
    <>
      {currentUser ? (
        <div className={Classes.avatarContainer}>
          <motion.div
            variants={{
              start: { opacity: 1, scale: 1 },
              end: { opacity: 0, scale: 0 },
            }}
            initial="start"
            animate="end"
            transition={{
              duration: 0.7,
              delay: 0.05,
            }}
            className={Classes.PorfileImagePreview}
          ></motion.div>

          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0 },
              visible: { opacity: 1, scale: 1 },
            }}
            initial="hidden"
            animate="visible"
            transition={{
              duration: 0.8,
              delay: 0.5,
            }}
            className={Classes.PorfileImageContainer}
            onClick={() => setShowModal(true)}
          >
            {getProfileImage(avatar, true)}
            <div
              className={"shadow-lg " + Classes.editActionContainer}
              onClick={() => setShowModal(true)}
            >
              <img src={EditIcon} alt="edit-Icon" />
            </div>
          </motion.div>
          {showInfo && (
            <motion.div
              className={Classes.nameContainer}
              variants={{
                hidden: { opacity: 0, y: -100 },
                visible: { opacity: 1, y: 0 },
              }}
              initial="hidden"
              animate="visible"
              transition={{
                duration: 0.8,
                delay: 0.2,
              }}
            >
              <div>
                <p>{currentUser.fullName}</p>
                <img src={VerifedIcon} alt="verifiedUser" />
              </div>
              <p>{currentUser.nationalCode}</p>
              <div
                className={Classes.pointContainer}
                onClick={() => navigate("/pointshop")}
              >
                <img src={RCoin} alt="coin" />
                <span>{userPoint}</span>
              </div>
            </motion.div>
          )}
        </div>
      ) : (
        <div style={{ height: "243px" }}></div>
      )}

      <CustomModal
        open={showModal}
        closeHandler={() => setShowModal(false)}
        inputDialog={true}
        dialogContent={<AvatarSelector changeHandler={handleChageAvatar} />}
      />
    </>
  );
};

export default ProfileAvatar;
